<script>
    export default {
        props: {
            viewURL: {
                type: String,
                required: false
            },
            title: {
                type: String,
                required: true
            },
            icon: {
                type: String,
                required: true
            },
            mainDivClasses: {
                type: String,
                required: true
            },
            minHeightStyle: {
                type: String,
                required: false
            }
        }
    };
</script>


<template>
    <div :class="mainDivClasses">
        <a :href="viewURL">
            <div class="card" :style="minHeightStyle">
                <div class="card-body p-4">
                    <div class="text-center">
                        <div class="avatar-md mx-auto mb-4">
                            <div class="avatar-title bg-light rounded-circle text-primary h1"  v-html="icon"></div>
                        </div>
                        <div class="row justify-content-center">
                            <div class="col-xl-10">
                                <span class="text-primary">
                                    {{ title }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </a>
    </div>
</template>